import { makeStyles } from "@material-ui/core/styles";

export function useAttendanceLocalMapStyles() {
  const useStyles = makeStyles((theme) => ({
    button: {
      color: "#004B97",
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 500,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    cardHeader: {
      color: "#fff",
      backgroundColor: "#004B97",
    },
    cardContent: {
      display: "flex",
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      flexDirection: "column",
      alignItems: "center",
    },
    cardActions: {
      justifyContent: "flex-end",
      borderTop: "1px solid #F0F0F0",
    },
    cardContentIFrameContainer: {
      "& iframe": {
        borderRadius: 5,
      },
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
